import React, { useCallback, useState } from "react"
import styled from "styled-components"
import { takeWhile } from "lodash"
import { useStaticQuery, graphql } from "gatsby"
import { motion } from "framer-motion"

import { device } from "utils"
import { Button, Link } from "components/common"

import BlogCard from "./BlogCard"

const BlogPosts = ({ readMoreIsLink, slug, limit }) => {
  const { blogPosts } = useStaticQuery(graphql`
    {
      blogPosts: allContentfulBlogPost(
        sort: { order: DESC, fields: date }
        filter: { slug: { ne: "placeholder" } }
      ) {
        edges {
          node {
            ...BlogPost
          }
        }
      }
    }
  `)

  const container = {
    hidden: { opacity: 1, scale: 0 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2,
      },
    },
  }

  const [blogLimit, setBlogLimit] = useState(limit)

  const loadMorePosts = () => setBlogLimit(blogLimit + 3)

  const showReadMore = blogPosts.edges.length > blogLimit

  const renderBlogPosts = useCallback(() => {
    const discoverMore = []

    takeWhile(blogPosts.edges, ({ node }) => {
      if (node.slug !== slug) {
        discoverMore.push(<BlogCard key={node.id} {...node} />)
      }
      return discoverMore.length < blogLimit
    })
    return discoverMore
    // return take(blogPosts.edges, blogLimit).reduce((bps, { node }) => {
    //   if (node.slug !== slug) {
    //     bps.push(<BlogCard key={node.id} {...node} />)
    //   }
    //   return bps
    // }, [])
  }, [blogPosts, blogLimit, slug])

  return (
    <StyledBlogPosts>
      <motion.ul
        className="blogPostsList"
        variants={container}
        initial="hidden"
        animate="visible"
      >
        {renderBlogPosts()}
      </motion.ul>
      {readMoreIsLink ? (
        <div className="btnWrap">
          <Link to="/blog">
            <Button>Read more posts</Button>
          </Link>
        </div>
      ) : (
        showReadMore && (
          <div className="btnWrap">
            <Button onClick={loadMorePosts}>Read more posts</Button>
          </div>
        )
      )}
    </StyledBlogPosts>
  )
}

const StyledBlogPosts = styled.div`
  .blogPostsList {
    display: grid;
    justify-content: center;
    grid-template-columns: 1fr;
    grid-gap: var(--sp-48);

    @media ${device.laptop} {
      grid-gap: var(--sp-64);
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .btnWrap {
    display: flex;
    justify-content: center;
    margin-top: var(--sp-48);
  }
`

BlogPosts.defaultProps = {
  limit: 6,
  readMoreIsLink: false,
}

export default BlogPosts
